
var dateHelper = (function () {
  function createDateFromJSON (jsonDateString) {
    var parts = jsonDateString.match(/(\d+)/g)
    var dt = new Date(parts[0], parts[1] - 1, parts[2])       // parse into yyyy, m, d
    var hours = jsonDateString.substring(11, 13)
    var minutes = jsonDateString.substring(14, 16)
    var seconds = jsonDateString.substring(17, 19)
    dt.setHours(hours, minutes, seconds, 0)
    return dt
  }

  function getShortDateString (dt) {
    var year = dt.getFullYear()
    var day = dt.getDate()
    var month = (dt.getMonth() + 1)
    return month + '/' + day + '/' + year
  }

  function createUrlDate (date) {
    let day   = date.getDate().toString()
    let month = (date.getMonth() + 1).toString() // Months in JavaScript are 0 indexed
    let year  = date.getFullYear().toString()

    if (day.length === 1) day = ('0' + day)
    if (month.length === 1) month = ('0' + month)

    return year + month + day
  }

  function getUrlDateString (startDate, endDate) {
    return '?start_date=' + createUrlDate(startDate) + '&end_date=' + createUrlDate(endDate)
  }

  return {
    createDateFromJSON:   createDateFromJSON,
    getShortDateString:   getShortDateString,
    createUrlDate:        createUrlDate,
    getUrlDateString:     getUrlDateString
  }
})()

export default dateHelper



// WEBPACK FOOTER //
// ./src/helpers/dateHelper.js